import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';
import LabellableComponent from '../../common/LabellableComponent/LabellableComponent';
import './SettingDropdown.css';

export type SettingDropdownOption = {
    key: number | string;
    text: string;
    description?: JSX.Element;
};

type Props = {
    label: string;
    required?: boolean;
    info?: string | JSX.Element;
    selectedKey: number | string;
    options: SettingDropdownOption[];
    disabled?: boolean;
    onChange: (key: number | string) => void;
};

const onRenderOption = (option?: IDropdownOption): JSX.Element | null => option
    ? <div className="setting-dropdown-option">
        <div className="setting-dropdown-option-title">{option.text}</div>
        {option.data?.description && <div className="setting-dropdown-option-description">{option.data.description}</div>}
    </div>
    : null;

export const SettingDropdown = (props: Props) => {
    const selected = props.options.find(_ => _.key === props.selectedKey);
    const options: IDropdownOption[] = props.options.map(_ => ({ key: _.key, text: _.text, data: { description: _.description } }));

    return <LabellableComponent className="setting-dropdown" label={props.label} required={props.required} description={props.info}>
        <Dropdown
            selectedKey={props.selectedKey}
            options={options}
            disabled={props.disabled}
            onRenderOption={onRenderOption}
            styles={{
                dropdownItem: { height: 'auto', whiteSpace: 'normal' },
                dropdownItemSelected: { height: 'auto', whiteSpace: 'normal' },
                dropdownItemDisabled: { height: 'auto', whiteSpace: 'normal' }
            }}
            onChange={(e, option) => option && props.onChange(option.key)}
        />
        {selected?.description && <div className="field-container-description">{selected.description}</div>}
    </LabellableComponent>;
};
